export default __webpack_public_path__ + "static/media/ykb.27f0d88f.png";